var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDownloadOnOrange = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 23"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#FA5500",
  d: "M9.167.001v18.98M17.651 10.267l-8.485 8.54-8.486-8.54M.5 22.001h18"
})));
export default SvgIconDownloadOnOrange;